import styled from 'styled-components'

import Button from 'components/Button'
import FormContainer from 'components/FormContainer'
import Layout from 'components/Layout'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const ActionWrapper = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: white;
    bottom: 0;
    left: 0;
    padding: 10px 0 0 0;
    position: fixed;
    width: 100%;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 10px 0px 65px;
  }
`

export const FormRow = styled.div`
  align-items: center;
  border-radius: 10px;
  box-shadow: ${style(theme => theme.shadows.lgMedium)});
  display: flex;
  font-size: 14px;
  height: 77px;
  line-height: 22px;
  padding: 20px;
`

export const FormRowList = styled.div`
  border-radius: 10px;
  box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
  width: 340px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 90px;
    width: 100%;
  }
`

export const FormRowListItem = styled(FormRow)`
  box-shadow: none;
  border-radius: 0;
  border-bottom: 1px solid #f5f5f5;
  height: 71px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export const Label = styled.label`
  margin: 0 10px 0 25px;
  position: relative;
  text-align: left;
  top: 1px;
`

export const StyledLayout = styled(Layout)`
  padding: 10px 0px 14px 0px;
`

export const StyledTitle = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin: 35px auto 6px;
`

export const StyledHeader = styled.h4`
  margin-bottom: 10px;
  text-align: left;
`

export const StyledBody = styled(Body)`
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 20px;
  max-width: 340px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`

export const StyledBodyLeftAlign = styled(StyledBody)`
  margin-left: 0;
  text-align: left;
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    bottom: 15px;
    height: 44px;
    margin: 8px 20px 20px 20px;
    position: sticky;
    width: calc(100vw - 40px);
  }
`

export const StyledImage = styled.img`
  height: auto;
  margin: 80px auto 0;
  max-width: 275px;
  width: 100%;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 0px;
  }
`

export const StyledFormContainer = styled(FormContainer)`
  border-radius: 10px;
  margin: 0 auto 20px;
  max-width: 100%;

  &&& {
    width: 315px;
    padding-bottom: 0;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    &&& {
      width: 100%;
    }
  }
`
